import useAuthStore from 'store/auth'

const GetUrls = () => {
  const user = useAuthStore((state) => state.user);
  const programId = user?.programId;

  const baseUrl = process.env.REACT_APP_API_HOST || 'https://kupidapi.tr4ns.com';
  // const thorBaseUrl = 'https://kupid-pos.tr4ns.com';

  // WESTFIELD ONLY
  // const thorBaseUrl = 'https://kupid-pos-wf.tr4ns.com';
  const thorBaseUrl = process.env.REACT_APP_API_THOR_HOST;

  const createUrl = (path: string, includesProgramId: boolean = true) => 
    `${baseUrl}${path}${includesProgramId ? `/${programId}` : ''}`;

  const createThorUrl = (path: string) => 
    `${thorBaseUrl}${path}/${programId}`;

  return {
    getReceiptFormat: (traderId: string) => createUrl(`/receiptDetail/${programId}/${traderId}`, false),
    getUser: (traderId: string) => createUrl(`/user/getbyprogramid?programId=${programId}&traderId=${traderId}`, false),
    getProduct: (traderId: string) => createUrl(`/product/getbyprogram/${programId}/${traderId}`, false),
    layout: (traderId: string) =>  createUrl(`/layout/${programId}/${traderId}`, false),
    getReceipt: (params: string) => createUrl(`/saleTransaction?programId=${programId}&${params}`, false),
    postLayout: createUrl('/layout', false),
    getButtonStyle: createUrl('/buttonStyle/getbyprogram'),
    postButtonStyle: createUrl('/buttonStyle', false),
    getDenominations: createUrl('/denominations'),
    postDenominations: createUrl('/denominations', false),
    productLayout: createUrl('/layout/product?layoutId=', false),
    getPaymentType: createUrl('/paymentType'),
    postPaymentType: createUrl('/paymentType', false),
    paymentTypeDetail: createUrl('/paymentTypeDetail', false),
    paymentTypes: createUrl('/paymentTypes', false),
    getPriceLevel: createUrl('/priceLevel/getbyprogram'),
    postPriceLevel: createUrl('/priceLevel', false),
    productDetails: createUrl('/productDetails', false),
    getProductPriceLevel: createUrl('/productpriceLevel', false),
    postProductPriceLevel: createUrl('/productpriceLevel', false),
    productTax: createUrl('/productTax', false),
    productTaxType: createUrl('/productTaxType', false),
    programDetail: createUrl('/programDetail', false),
    getTax: createUrl('/tax'),
    postTax: createUrl('/tax', false),
    postUser: createUrl('/user', false),
    postChangeUserPassword: createUrl('/user/changepassword', false),
    getUserType: createUrl('/userType'),
    postUserType: createUrl('/userType', false),
    updateReceiptFormat: createUrl('/receiptDetail/', false),
    postProduct: createUrl('/product', false),
    getClass: createUrl('/class/getbyprogram'),
    postClass: createUrl('/class', false),
    getSubclass: createUrl('/subClass/getbyprogram'),
    postSubclass: createUrl('/subClass', false),
    
    /** THOR API **/ 
    getDepartment: createThorUrl('/departments'),
    postDepartment: `${thorBaseUrl}/departments/insert`,
    updateDepartment: `${thorBaseUrl}/departments/update`,
    
    postProductAlt: createThorUrl('/products'),
    updateProductAlt: createThorUrl('/products'),
    // postProductAlt: `${thorBaseUrl}/products/insert`,
    // updateProductAlt: `${thorBaseUrl}/products/update`,

    postClassAlt: `${thorBaseUrl}/classes/insert`,
    updateClassAlt: `${thorBaseUrl}/classes/update`,
    
    postSubclassAlt: `${thorBaseUrl}/subclasses/insert`,
    updateSubclassAlt: `${thorBaseUrl}/subclasses/update`,
    
    getCategory: createThorUrl('/categories'),
    postCategory: `${thorBaseUrl}/categories/insert`,
    updateCategory: `${thorBaseUrl}/categories/update`,
    
    getSubcategory: createThorUrl('/subcategories'),
    postSubcategory: `${thorBaseUrl}/categories/insert`,
    updateSubcategory: `${thorBaseUrl}/categories/update`,
  }
}

export default GetUrls;